'use client';
function getStartOfWeek(date, firstDayOfWeek = 1) {
  const value = new Date(date);
  while (value.getDay() !== firstDayOfWeek) {
    value.setDate(value.getDate() - 1);
  }
  return value;
}

export { getStartOfWeek };
//# sourceMappingURL=get-start-of-week.mjs.map
